import { createSlice } from '@reduxjs/toolkit';
import { fetchUserWarranty } from '../services/fetchUserWarranty';
import { UserWarrantySchema } from '../types/userWarrantySchema';

const initialState: UserWarrantySchema = {
  userWarranty: [],
  isLoadedUserWarranty: false,
  isError: null,
};

export const warrantyUserSlice = createSlice({
  name: 'warrantyUser',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(fetchUserWarranty.pending, state => {
      state.isLoadedUserWarranty = false;
    });
    builder.addCase(fetchUserWarranty.fulfilled, (state, action) => {
      if (action.payload) {
        state.userWarranty = action.payload.filter(x => x.status === 'Действует');
      }
      state.isLoadedUserWarranty = true;
    });
    builder.addCase(fetchUserWarranty.rejected, (state, action) => {
      state.isError = { code: action.payload.code };
      state.isLoadedUserWarranty = true;
    });
  },
});

export const { actions: warrantyUserActions } = warrantyUserSlice;
